import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Gift, FilePdf, Headphones, CalendarCheck, Lock } from "@phosphor-icons/react";
import { api } from "../lib/api";
import ShareStreak from "./ShareStreak";

const Milestone = ({ unlocked, at, current, title, testid, children }) => (
  <div data-testid={testid} className={`border p-5 flex-1 min-w-[16rem] ${unlocked ? "border-exodus-gold bg-exodus-gold/5" : "border-exodus-border"}`}>
    <p className="eyebrow flex items-center gap-2">{unlocked ? <Gift size={14} weight="fill" /> : <Lock size={14} />} {at} check-ins in a row</p>
    <p className="font-display text-2xl mt-2">{title}</p>
    {unlocked ? <div className="mt-4 flex flex-wrap gap-3">{children}</div> : (
      <>
        <div className="h-1 bg-exodus-border mt-4"><div className="h-1 bg-exodus-gold" style={{ width: `${Math.min(100, (current / at) * 100)}%` }} /></div>
        <p className="text-[11px] text-exodus-muted mt-2">{Math.max(0, at - current)} more check-in{at - current === 1 ? "" : "s"} in a row to unlock</p>
      </>
    )}
  </div>
);

export default function RewardsCard({ rewards, streak, className = "" }) {
  const [audioUrl, setAudioUrl] = useState(null);
  const [busy, setBusy] = useState("");
  if (!rewards || !streak) return null;

  const blob = async (path, type) => {
    const r = await api.get(path, { responseType: "blob" });
    return URL.createObjectURL(new Blob([r.data], { type }));
  };
  const playbook = async () => {
    setBusy("pdf");
    try {
      const url = await blob("/app/rewards/playbook", "application/pdf");
      const a = Object.assign(document.createElement("a"), { href: url, download: "exodus-tax-free-playbook.pdf" });
      document.body.appendChild(a); a.click(); a.remove();
    } catch { toast.error("Could not download your playbook."); } finally { setBusy(""); }
  };
  const bonus = async () => {
    setBusy("audio");
    try { setAudioUrl(await blob("/app/rewards/bonus-audio", "audio/mpeg")); }
    catch { toast.error("Your bonus episode audio is being prepared — please try again later."); } finally { setBusy(""); }
  };

  return (
    <section data-testid="rewards-card" className={`card-surface p-6 sm:p-8 ${className}`}>
      <p className="eyebrow mb-4">Streak rewards</p>
      <div className="flex flex-wrap gap-4">
        <Milestone testid="reward-7" unlocked={rewards.playbook_unlocked} at={rewards.playbook_at} current={streak.current} title="Tax-Free Retirement Playbook + bonus episode">
          <button data-testid="reward-playbook-download" onClick={playbook} disabled={busy === "pdf"} className="btn-gold text-xs"><FilePdf size={16} /> {busy === "pdf" ? "Preparing…" : "Download playbook"}</button>
          <button data-testid="reward-bonus-play" onClick={bonus} disabled={busy === "audio"} className="btn-ghost text-xs"><Headphones size={16} /> {busy === "audio" ? "Loading…" : "Play bonus episode"}</button>
          {audioUrl && <audio data-testid="reward-bonus-audio" src={audioUrl} controls autoPlay className="w-full" />}
          <ShareStreak />
        </Milestone>
        <Milestone testid="reward-12" unlocked={rewards.free_booking_unlocked} at={rewards.free_booking_at} current={streak.current} title="Free Illustration Review — no $100 fee">
          {rewards.free_booking_used
            ? <p data-testid="reward-free-used" className="text-sm text-exodus-emerald">Redeemed — enjoy your review with Leon.</p>
            : <Link data-testid="reward-free-book" to="/reserve" className="btn-gold text-xs"><CalendarCheck size={16} /> Book my free review</Link>}
        </Milestone>
      </div>
    </section>
  );
}
